<template>
  <div style="padding: 0 10px">
    <div style="display: flex; justify-content: flex-start; align-items: center" class="headerBox">
      <div class="searchbox">
        <div class="infoBox">
          <ScanQuery ph="输入批次包" @onQuery="queryCall" ref="ScanQuery" />
          <span class="receiverNation" v-if="receiverNation">收货国家:{{ receiverNation }}</span>
          <div style="flex:1">
          </div>
          <div class="limitBox" v-if="customerShopName">客户店铺名称：{{ customerShopName }}</div>
          <el-tag type="warning" effect="dark" v-if="allIncludeFlag === 1">一价全包</el-tag>
          <div class="limitBox" style="margin-left: 20px">重量上限:{{ weightLimit }}kg 美元上限:{{ priceLimit }}美元</div>
          <div style="display: flex; margin-left: 20px">
            <!-- <IptNumber placeholder="重量" :value="weight" unit="克" @change="(val) => antiShake(weightSet, val)"
              @enter="weightSet" ref='weightIpt' /> -->
            <IptNumber placeholder="重量" :value="weight" unit="克" @enter="weightSet" ref='weightIpt' />
            <!-- <IptNumber :value="packageNums" placeholder="包裹数量" unit="件" @change="(val) => antiShake(bagNumChange, val)" @enter="bagNumChange"/> -->
          </div>
        </div>
        <div class="splitBox">
          <div style="width: 440px;">
            <el-select style="margin-right:10px;width:140px" v-model="boxCode" @change="selectBoxTemplate">
              <el-option v-for="item in boxTemplates" :key="item.boxTemplateId" :label="item.templateName"
                :value="item.boxTemplateId">
              </el-option>
            </el-select>
            <el-input style="width: 80px" placeholder="长" v-model="boxSizeInfo.length"></el-input> *
            <el-input style="width: 80px" placeholder="宽" v-model="boxSizeInfo.width"></el-input> *
            <el-input style="width: 80px" placeholder="高" v-model="boxSizeInfo.height"></el-input>
          </div>
          <div style="flex:1">
            <template v-if="customerTagNameList?.length">
              <div class="publicCustomerTagName" v-for="item in customerTagNameList" :key="item">{{ item }}</div>
            </template>
          </div>
          <el-input maxlength='450' style="width: 300px" v-model="newLogisticsCode" placeholder="手动设置快递单号"
            @change="setShipNumber">
            <template slot="prepend">{{ wmsForwarder ? wmsForwarder : '物流公司名字' }}</template>
          </el-input>
        </div>
      </div>
      <div style="display:flex ; margin-left: 10px; flex-wrap: wrap;align-content: space-between;">
        <el-button type="primary" style="margin: 5px" @click="setShipNumber">提交物流单号</el-button>
        <el-button type="primary" style="margin: 5px" @click="createWaybillNumber"
          :disabled="!!newLogisticsCode">生成物流单号</el-button>
        <el-button type="success" style="margin: 5px" @click="buildFinish">
          打包完成
        </el-button>
      </div>

    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>单证备注信息</span>
      </div>
      <div style="text-align: left">
        备注内容：<span style="color:red;font-size: 26px">{{ auditRemark || '-' }}</span>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申报信息</span>
      </div>
      <WmsTable :columns="columns" :hasHeader="false" :is-pagination="false" :dataSource="additionalDataSource">
        <div slot="image" slot-scope="{text}">
          <img :src="text" alt="" style="width:60px;">
        </div>
      </WmsTable>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ `当前国际发货单号：${deliveryTaskCode}；批次包号：${query.code}；${companyCode}` }}</span>
      </div>
      <WmsTable :columns="columnsTwo" :hasHeader="false" :is-pagination="false" :dataSource="productDataSource">
        <div slot="productImg" slot-scope="{ text }">
          <img :src="text" alt="" style="width: 60px" />
        </div>
        <!-- <div slot="productName" slot-scope="{text,reocrd}">

        </div> -->
      </WmsTable>
    </el-card>
    <el-dialog title="容器扫描" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div>请扫描当前正在打包的容器号</div>
      <el-input ref='containerIpt' @change="containerIptSubmit" v-model="dialogContainerCode"></el-input>
    </el-dialog>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import IptNumber from "@/components/IptNumber";
import WmsTable from "@/components/WmsTable";
import { audioPay } from "@/utils/tools";
import {
  finishBuildBag,
  getLogisticsInfoList,
  getSmallBagMultiDetail,
  getSmallBagSingleDetail,
  setLogisticstInfo,
  setSmallBagWeight,
  getLogisticsNo,
  singleCheck,
  getBox
} from "@/apis/outStock";
import { smallContainer } from '../mixins/smallContainer'
export default {
  name: "SmallSingleBuilding", // 小件单品打包
  mixins: [smallContainer],
  components: {
    ScanQuery,
    IptNumber,
    WmsTable

  },
  data() {
    return {
      query: {
        code: '',
        // current: 1,
        // pageSize: 10,
        // total: 0
      },
      deliveryTaskCode: '', // 发货任务编号
      wmsForwarder: '',
      companyCode: '',
      columns: [
        { title: '附加项名称', key: 'additionName', dataIndex: 'additionName' },
        { title: '辅料名称', key: 'ingredientsName', dataIndex: 'ingredientsName' },
        {
          title: '辅料图片', key: 'image', dataIndex: 'image',
          scopedSlots: {
            customRender: "image",
          },
        },
        { title: '辅料SKU', key: 'ingredientsSku', dataIndex: 'ingredientsSku' },
      ],
      columnsTwo: [
        {
          title: '图片',
          key: 'productImg',
          dataIndex: 'productImg',
          scopedSlots: {
            customRender: "productImg",
          },
        },
        {
          title: '商品名称',
          key: 'productName',
          dataIndex: 'productName',
        },
        { title: '商品SKU', key: 'shopProductSku', dataIndex: 'shopProductSku' },
        { title: '批次包编码', key: 'pkgCode', dataIndex: 'pkgCode' },
        { title: '数量', key: 'deliveryNums', dataIndex: 'deliveryNums' },
      ],
      customerShopName: '',
      additionalDataSource: [],
      productDataSource: [],
      links: [],
      interceptStatus: false,
      receiverNation: '',
      auditRemark: '',
      dialogVisible: false,
      dialogContainerCode: '',
      containerCode: '',
      boxTemplates: [],
      boxCode: '',
      boxSizeInfo: {},
      customerTagNameList: [],
      allIncludeFlag: 0
    }
  },
  computed: {
    //sku种类数量
    skuNum() {
      var skuList = [];
      this.productDataSource.forEach((item) => {
        if (skuList.indexOf(item.productSku) == -1) {
          skuList.push(item.productSku);
        }
      });
      return skuList.length;
    },
    //总商品数
    totalNum() {
      var num = 0;
      this.productDataSource.forEach((item) => {
        num += item.deliveryNums;
      });
      return num;
    },
    focusTarget() {
      if (this.dialogVisible) {
        return this.$refs.containerIpt
      }
      if (this.productDataSource.length) {
        return this.$refs.weightIpt
      }
      return this.$refs.ScanQuery
    }
  },
  mounted() {
    var focusFunc = setInterval(() => {
      if (!!window.getSelection().toString()) {
        return
      }
      if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
        return
      }
      if (this.dialogVisible) {
        this.focusTarget.focus()
        return
      }
      this.focusTarget.focusIpt ? this.focusTarget.focusIpt() : this.focusTarget.$el.children[0].children[1].children[0].focus()
    }, 300);

    getBox().then(({ code, data }) => {
      if (code == 0) {
        this.boxTemplates = data;
      }
    });
  },
  methods: {
    queryCall: function (payload) {
      this.query.code = payload.code
      // this.getDetails()
      this.getSingleCheck()
    },
    getSingleCheck() {
      const that = this
      const params = {
        pkgCode: that.query.code
      }
      singleCheck(params).then(res => {
        if (res.data.hasMoreContainer) {
          this.focusTarget.focusBlur()
          this.dialogVisible = true
          return
        }
        this.getDetails()
      })
    },
    containerIptSubmit(val) {
      console.log(val)
      this.containerCode = val
      this.dialogContainerCode = ''
      this.getDetails()
    },
    getDetails: function () {
      const that = this
      const prams = {
        pkgCode: that.query.code
      }
      this.containerCode && (prams.containerCode = this.containerCode)
      getSmallBagSingleDetail(prams).then(({ code, data = {} }) => {
        if (code === 0) {
          that.dialogVisible = false
          audioPay(`单品打包`)
          const { deliveryTaskAdditionalDetailList = [], taskDetailList = [], deliveryTaskCode = '', customerShopName, wmsForwarder, logisticsCompanyCode, interceptStatus, wmsIntForwarderConfigId, auditRemark, receiverNation, customerTagNameList, allIncludeFlag } = data
          that.interceptStatus = interceptStatus
          that.companyCode = logisticsCompanyCode
          that.wmsIntForwarderConfigId = wmsIntForwarderConfigId
          that.additionalDataSource = deliveryTaskAdditionalDetailList
          that.customerShopName = customerShopName
          that.wmsForwarder = wmsForwarder
          that.receiverNation = receiverNation
          that.auditRemark = auditRemark
          that.customerTagNameList = customerTagNameList
          that.productDataSource = taskDetailList.map((item) => {
            return {
              ...item,
              pkgCode: that.query.code
            }
          })
          that.allIncludeFlag = allIncludeFlag
          that.deliveryTaskCode = deliveryTaskCode
          that.getLogisticsInfo()
          this.$refs['weightIpt'].focus()
        }
      })
    },

    createWaybillNumber: function () {
      let params = {
        deliveryTaskCode: this.deliveryTaskCode,
      };
      getLogisticsNo(params).then(({ code }) => {
        if (code == 0) {
          this.$message.success("操作成功");
          this.getDetails()
        }
      });
    },
    // 选中箱子模板
    selectBoxTemplate: function (val) {
      const that = this
      // 当选中固定模板时
      if (!!val && val !== '') {
        that.boxTemplates.forEach(item => {
          if (item.boxTemplateId === val) {
            const { width, length, height } = item
            that.boxSizeInfo = {
              width,
              length,
              height
            }
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.box-card ::v-deep.el-card__header {
  background: #f8f8f8;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

.limitBox {
  border: 1px #eee solid;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px 10px;
  color: red;
}

#pdf {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: -1;
}

.receiverNation {
  font-size: 20px;
  font-weight: 600;
  margin-left: 10px;
}

.headerBox {
  background-color: #ddeeff;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.headerBox .headerBtn {
  height: 80px;
}

.searchbox {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
}

.infoBox {
  display: flex;
  align-items: center;
  width: 100%;
}

.splitBox {
  display: flex;
  flex-shrink: 0;
  text-align: left;
  width: 100%;
}
</style>